export const clientConsent = {
  page: {
    title: "Hozzáférés engedélyezése",
    subtitle: (clientName: string) => `A(z) ${clientName} hozzáférést kér a fiókjához.`,
    loading: "Betöltés…",
  },

  form: {
    scopesIntro: "Az engedélyezés után az alkalmazás a nevében a következőkre lesz képes:",
    acceptButton: "Engedélyezés",
    denyButton: "Elutasítás",
    redirectingAfterAccept: (clientName: string) =>
      `Engedélyezve. Visszairányítjuk a(z) ${clientName} alkalmazásba…`,
    redirectingAfterDeny: (clientName: string) =>
      `Elutasítva. Visszairányítjuk a(z) ${clientName} alkalmazásba…`,
  },

  errors: {
    subtitle: "A hozzáférési kérés nem dolgozható fel.",
    invalidRequest:
      "A hozzáférési kérés érvénytelen. Indítsa újra a csatlakozást az alkalmazásból.",
    unknownClient: "Az alkalmazás nincs regisztrálva.",
  },
} as const;
